import { HTTP } from '@/axios_api/http-common'
import { stat } from 'fs';

const state = {
    notifications: [],
}

interface IState {
    notifications: Array<any>
}

const mutations = {
    setNotifications(state: IState, notifications: Array<any>) {
        state.notifications = notifications
    }
}


const getters = {
    isNotificationEmpty:(state:IState) => {
        return state.notifications.length<1
    },
    getNotifications:(state:IState) => {
        return state.notifications
    },
    getNumberOfUnreadNotifications: (state: IState) =>{
        return state.notifications.length
    }
}

const actions={
    getNotificaionsAction({ commit,rootState }: { commit : any,rootState:any }) {
        return new Promise((resolve: any, reject: any) => {
            HTTP.get('notifications?userId='+rootState.activeUser.id).then((response: any) => {                       
              commit('setNotifications', response.data.data)	
              resolve(response)    
            })
            .catch((error: any) => {
              reject(error)
            })
        })         
    },
    markNotificationAsReadAction ({ commit } : { commit : any}, ids:Array<Number>) {
        return new Promise((resolve, reject) => {
            commit('markAsRead',ids)   
            HTTP.post('notifications/read', ids)
            .then((response: any) => {
                resolve()
            })
            .catch((error: any) => {
              reject(error)
            })
        })
    },
}

const notificationsModule={
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}

export default notificationsModule